/**
 * Routes where the corner button is the roadmap agent.
 * Zendesk chat stays available on the rest of the app.
 */

const ROADMAP_WORKSPACE_PREFIXES = [
  '/admin/roadmap/requests',
  '/admin/roadmap/sprints',
  '/admin/roadmap/my-work',
] as const;

/** Tickets, Roadmap, Sprints, and My Work, including a ticket or sprint detail. */
export function isRoadmapWorkspacePath(pathname: string): boolean {
  if (pathname === '/admin/roadmap') return true;
  return ROADMAP_WORKSPACE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
